var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconEstateFeature4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 46 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.36 3.322C36.406 4.476 45.001 13.812 45.001 25c0 7.362-3.732 13.873-9.428 17.79M20.643 46.677C9.596 45.524 1 36.187 1 25c0-7.37 3.732-13.874 9.429-17.791M22.998 5.645c1.302 0 2.357-1.04 2.357-2.322C25.355 2.04 24.3 1 22.998 1c-1.302 0-2.357 1.04-2.357 2.323 0 1.282 1.055 2.322 2.357 2.322Z",
  stroke: "#999",
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.998 49c1.302 0 2.357-1.04 2.357-2.322 0-1.283-1.055-2.322-2.357-2.322-1.302 0-2.357 1.04-2.357 2.322 0 1.283 1.055 2.323 2.357 2.323Z",
  stroke: "#999",
  strokeMiterlimit: 10
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.086 18.032c2.648-5.489 8.329-9.29 14.913-9.29s12.265 3.801 14.913 9.29M37.912 31.969c-2.648 5.489-8.329 9.29-14.913 9.29s-12.265-3.794-14.913-9.29M8.852 25h28.285",
  stroke: "#B18D3B",
  strokeMiterlimit: 10
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.782 13.496c-2.734 1.82-6.992 2.989-11.785 2.989s-9.052-1.17-11.786-2.989M11.211 36.504c2.734-1.82 6.993-2.988 11.786-2.988 4.793 0 9.051 1.169 11.785 2.988M6.498 27.323c1.302 0 2.357-1.04 2.357-2.323 0-1.282-1.055-2.322-2.357-2.322-1.302 0-2.357 1.04-2.357 2.322 0 1.283 1.055 2.323 2.357 2.323ZM39.498 27.323c1.302 0 2.357-1.04 2.357-2.323 0-1.282-1.055-2.322-2.357-2.322-1.302 0-2.357 1.04-2.357 2.322 0 1.283 1.055 2.323 2.357 2.323Z",
  stroke: "#B18D3B",
  strokeMiterlimit: 10
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M23 41.258c3.038 0 5.5-7.279 5.5-16.258S26.038 8.742 23 8.742 17.5 16.022 17.5 25c0 8.98 2.462 16.258 5.5 16.258Z",
  stroke: "#B18D3B",
  strokeMiterlimit: 10
})));

export default SvgIconEstateFeature4;